/* Bank only. "$X - JOIN PUP CLUB" buttons: adds the item, then adds Pup Club so the cart opens with it picked. 2026-09-30 */
(function () {
  var KEY = 'pk-join-club';
  var isActiveMember = function () { return window.PK_PUP_CLUB_AUTH && window.PK_PUP_CLUB_AUTH.authenticated === true && window.PK_PUP_CLUB_AUTH.activeMember === true; };
  /* 2026-10-08: only a signed-out shopper may join from a product button. The test
     account counts as a member; a session still being verified is never a guest. */
  var identity = function () {
    var lock = window.PKDemoActionLock;
    if (lock && typeof lock.identity === 'function') { try { return lock.identity(); } catch (e) { return 'resolving'; } }
    return isActiveMember() ? 'member' : 'guest';
  };
  var painters = new WeakMap();
  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
  function cents(t) { var m = (t || '').match(/\$([\d,]+\.\d{2})/); return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : null; }
  // keep the Pup Club price in step with the main button when a tier or color changes
  function mirror(btn) {
    var main = btn.previousElementSibling; if (!main) return;
    var src = main.querySelector('[data-pm-cta-label]') || main;
    var paint = function () { if (isActiveMember()) return; var c = cents(src.textContent); var lab = btn.querySelector('[data-pk-club-label]') || btn; lab.textContent = (c ? money(window.PK_CLUB_IN_CART === true ? c : Math.round(c / 2)) + ' - ' : '') + 'JOIN PUP CLUB' + (/→/.test(src.textContent) ? ' →' : ''); };
    painters.set(btn, paint); paint(); new MutationObserver(paint).observe(src, { childList: true, characterData: true, subtree: true });
  }
  function arm() { document.querySelectorAll('[data-pk-club-mirror]').forEach(function (b) { if (!b.dataset.pkMirrored) { b.dataset.pkMirrored = '1'; mirror(b); } }); }
  async function itemCount() { try { var r = await fetch('/cart.js', { credentials: 'same-origin' }); return (await r.json()).item_count; } catch (e) { return null; } }
  async function finish(before) {
    for (var i = 0; i < 40; i++) {
      if (identity() !== 'guest') { try { sessionStorage.removeItem(KEY); } catch (e) {} return; }
      await new Promise(function (r) { setTimeout(r, 400); });
      var n = await itemCount(); var d = document.querySelector('pm-cart-drawer');
      if (n !== null && n > before && d && typeof d.addMembership === 'function') {
        try { sessionStorage.removeItem(KEY); } catch (e) {}
        if (typeof d.open === 'function' && !d.classList.contains('is-open')) await d.open();
        await d.addMembership();
        return;
      }
    }
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  }
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.pk-club-btn'); if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var who = identity();
    if (who === 'member' || who === 'demo' || isActiveMember()) { e.stopImmediatePropagation(); return; }
    var main = btn.previousElementSibling; if (!main || main.disabled) return;
    if (who === 'resolving') { e.stopImmediatePropagation(); if (window.PKDemoActionLock) window.PKDemoActionLock.notify(btn, 'Checking your account. Please try again in a moment.'); return; }
    /* Signed in without active benefits: the product is added on its own, never the membership. */
    if (who !== 'guest') { main.click(); return; }
    try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
    var before = await itemCount(); if (before === null) before = 0;
    main.click(); finish(before);
  }, true);
  ['pk:member-state', 'pk:auth-state', 'pk:club-cart'].forEach(function (name) { addEventListener(name, function () { arm(); queueMicrotask(function () { document.querySelectorAll('[data-pk-club-mirror]').forEach(function (btn) { var paint = painters.get(btn); if (paint) paint(); }); }); }); });
  new MutationObserver(arm).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') arm(); else document.addEventListener('DOMContentLoaded', arm);
})();
